import {
	APPEND_PRE_ORDER_SETTINGS,
	SET_PRE_ORDER_SETTINGS,
	SET_PRE_ORDER_SETTINGS_TOTAL,
	UPDATE_PRE_ORDER_SETTINGS_ROW,
} from '../../actionTypes/preOrderSettings'

const initialState = {
	preOrderSettings: [],
	preOrderSettingsTotal: 0,
}

export function preOrderSettingsReducer(state = initialState, action) {
	switch (action.type) {
		case SET_PRE_ORDER_SETTINGS:
			return { ...state, preOrderSettings: action.value }
		case APPEND_PRE_ORDER_SETTINGS:
			return { ...state, preOrderSettings: state.preOrderSettings.concat(action.value) }
		case SET_PRE_ORDER_SETTINGS_TOTAL:
			return { ...state, preOrderSettingsTotal: action.value }
		case UPDATE_PRE_ORDER_SETTINGS_ROW:
			return {
				...state,
				preOrderSettings: state.preOrderSettings.map(row =>
					row.categoryId === action.value.categoryId ? { ...row, ...action.value } : row
				),
			}
		default:
			return state
	}
}
